<div class="h-full flex-col">
  <div
       *ngIf="siteFound | showNavbar: currentRoute"
       class="sticky top-0 z-NAVBAR bg-light">
    <div class="mx-auto max-w-CONTENT mobile:px-5 laptop:px-8 ">
      <div class="grid-row">
        <div class="col-span-12 desktop:col-span-10 desktop:col-start-2">
          <ng-container *ngIf="applicantSitesNav$ | async as applicantSitesNav">
            <onboarding-navbar-section
                                       [logoUrl]="siteConfig.globalStyles.headerLogoUrl"
                                       [brandStyles]="siteConfig.globalStyles"
                                       [navbarType]="navbarType"
                                       [navigationItems]="siteConfig.navigation.siteNavigationItems"
                                       [currentRoute]="currentRoute"
                                       [applicantSitesNav]="applicantSitesNav"
                                       (onToggleBurgerMenuEvent)="onToggleBurgerMenu($event)">
            </onboarding-navbar-section>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="min-h-[calc(100%-286px)]">
    <router-outlet></router-outlet>
  </div>

  <div *ngIf="siteFound" [ngClass]="isBurgerMenuOpen ? 'overflow-hidden' : ''"
       class="mx-auto mt-auto max-w-CONTENT mobile:px-5 laptop:px-8 overflow-y-auto">
    <div class="grid-row">
      <footer-section [showLogoInFooter]="siteConfig.globalStyles.showLogoInFooter"
                      [websiteUrl]="siteConfig.globalStyles.socialMediaHandles.companyUrl"
                      [instagramUrl]="siteConfig.globalStyles.socialMediaHandles.instagramUrl"
                      [facebookUrl]="siteConfig.globalStyles.socialMediaHandles.facebookUrl"
                      [linkedInUrl]="siteConfig.globalStyles.socialMediaHandles.linkedInUrl"
                      [twitterUrl]="siteConfig.globalStyles.socialMediaHandles.twitterUrl"
                      [companyName]="siteConfig.globalStyles.companyName"
                      [logoUrl]="siteConfig.globalStyles.headerLogoUrl"
                      [brandStyles]="siteConfig.globalStyles"
                      [showPoweredByTalos]="siteConfig.globalStyles.showPoweredByTalos"
                      class="block col-span-12 desktop:col-span-10 desktop:col-start-2 py-8">
      </footer-section>
    </div>
  </div>
</div>
<!-- toasts -->
<toast-alert-component></toast-alert-component>
